import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import { CircularProgress, TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import AjaxHandler from '../../../commons/ajax/AjaxHandler.js';
import Security from '../../../commons/security/Security.js';
import Loading from '../../ui/Loading.js';

const URL_REGLAS = '/disponibilidad/reglas';
const URL_RENTADORAS_SELECT = '/rentadoras/select';

class DisponibilidadReglasAbm extends Component {
  constructor(props) {
    super(props);
    this.ajaxHandler = new AjaxHandler();

    // La regla se recibe via location.state (no hay endpoint GET /reglas/:id)
    const regla =
      props.location && props.location.state && props.location.state.regla
        ? props.location.state.regla
        : null;

    // Las reglas existentes se reciben via location.state para filtrar el select de locadoras
    const reglasExistentes =
      props.location && props.location.state && props.location.state.reglasExistentes
        ? props.location.state.reglasExistentes
        : [];

    this.state = {
      redirectTo: null,
      loading: false,
      rentadoras: [],
      regla: regla,
      reglasExistentes: reglasExistentes,
      formData: {
        rentadora_id: regla ? String(regla.rentadora_id) : '',
        valor_int: regla ? String(regla.valor_int) : '',
      },
      // Objeto completo seleccionado en el Autocomplete (solo para ADD)
      rentadoraSeleccionada: null,
      errors: {},
      errorBackend: null,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleRentadoraChange = this.handleRentadoraChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancelar = this.handleCancelar.bind(this);
    this.salir = this.salir.bind(this);
  }

  componentDidMount() {
    if (!Security.hasPermission('DISPONIBILIDAD_REGLAS_MODIFICAR')) {
      this.setState({ redirectTo: '/error' });
      return;
    }
    this.ajaxHandler.subscribe(this);

    // Solo necesitamos cargar el select de rentadoras (solo para ADD)
    if (this.props.action === 'ADD') {
      this.cargarRentadoras();
    }
  }

  componentWillUnmount() {
    this.ajaxHandler.unsubscribe();
  }

  cargarRentadoras() {
    this.setState({ loading: true });
    this.ajaxHandler
      .getJson(URL_RENTADORAS_SELECT)
      .then((data) => {
        const rentadoras = Array.isArray(data) ? data : [];
        this.setState({ rentadoras: rentadoras });
      })
      .catch((error) => {
        this.ajaxHandler.handleError(error);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  /**
   * Retorna las rentadoras disponibles para el select de alta.
   * Excluye las que ya tienen regla configurada (recibidas desde el Grid via location.state).
   */
  getRentadorasDisponibles() {
    const reglasExistentes = this.state.reglasExistentes;
    const idsConRegla = reglasExistentes.map(function(r) {
      return r.rentadora_id;
    });

    return this.state.rentadoras.filter(function(rentadora) {
      return idsConRegla.indexOf(rentadora.id) === -1;
    });
  }

  handleInputChange(event) {
    const target = event.target;
    const name = target.name;
    const value = target.value;

    const formDataCopy = Object.assign({}, this.state.formData);
    formDataCopy[name] = value;

    // Limpiar error del campo al modificarlo
    const errorsCopy = Object.assign({}, this.state.errors);
    delete errorsCopy[name];

    this.setState({
      formData: formDataCopy,
      errors: errorsCopy,
      errorBackend: null,
    });
  }

  handleRentadoraChange(event, rentadora) {
    const formDataCopy = Object.assign({}, this.state.formData);
    formDataCopy.rentadora_id = rentadora ? String(rentadora.id) : '';

    const errorsCopy = Object.assign({}, this.state.errors);
    delete errorsCopy.rentadora_id;

    this.setState({
      formData: formDataCopy,
      rentadoraSeleccionada: rentadora,
      errors: errorsCopy,
      errorBackend: null,
    });
  }

  validar() {
    const errores = {};
    const rentadora_id = this.state.formData.rentadora_id;
    const valor_int = this.state.formData.valor_int;

    if (this.props.action === 'ADD' && !rentadora_id) {
      errores.rentadora_id = this.props.intl.formatMessage({
        id: 'disponibilidadReglas.validacion.locadora_requerida',
        defaultMessage: 'Debe seleccionar una locadora',
      });
    }

    const valorNumerico = parseInt(valor_int, 10);
    if (valor_int === '' || valor_int === null || isNaN(valorNumerico)) {
      errores.valor_int = this.props.intl.formatMessage({
        id: 'disponibilidadReglas.validacion.dias_mayor_cero',
        defaultMessage: 'El umbral de días debe ser mayor a 0',
      });
    } else if (valorNumerico < 1) {
      errores.valor_int = this.props.intl.formatMessage({
        id: 'disponibilidadReglas.validacion.dias_mayor_cero',
        defaultMessage: 'El umbral de días debe ser mayor a 0',
      });
    }

    return errores;
  }

  handleSubmit(event) {
    event.preventDefault();

    const errores = this.validar();
    if (Object.keys(errores).length > 0) {
      this.setState({ errors: errores });
      return;
    }

    this.setState({ loading: true, errorBackend: null });

    const esEdicion = this.props.action === 'EDIT';
    const id = esEdicion ? this.props.match.params.id : null;

    const body = esEdicion
      ? { valor_int: parseInt(this.state.formData.valor_int, 10) }
      : {
          rentadora_id: parseInt(this.state.formData.rentadora_id, 10),
          valor_int: parseInt(this.state.formData.valor_int, 10),
        };

    this.ajaxHandler
      .fetch(URL_REGLAS + (esEdicion ? '/' + id : ''), {
        method: esEdicion ? 'PUT' : 'POST',
        body: JSON.stringify(body),
      })
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          this.salir();
          return;
        }

        if (response.status === 422) {
          // El backend retorna { "error": "..." } o { "mensaje": "..." } para 422.
          // handleResponseErrorsIsValid mostraría "Error interno del sistema" genérico
          // para status >= 404, por eso manejamos 422 manualmente para preservar el mensaje específico.
          response.json().then((data) => {
            const mensaje =
              data && data.error
                ? data.error
                : data && data.mensaje
                ? data.mensaje
                : this.props.intl.formatMessage({
                    id: 'disponibilidadReglas.error.generico',
                    defaultMessage: 'Ocurrió un error al guardar',
                  });
            this.setState({ errorBackend: mensaje, loading: false });
          });
          return;
        }

        // Para 401, 403, 500+: delegar al handler estándar
        this.ajaxHandler.handleResponseErrorsIsValid(response);
        this.setState({ loading: false });
      })
      .catch((error) => {
        this.ajaxHandler.handleError(error);
        this.setState({ loading: false });
      });
  }

  handleCancelar() {
    this.salir();
  }

  salir() {
    this.setState({ redirectTo: '/disponibilidad/reglas' });
  }

  render() {
    const redirectTo = this.state.redirectTo;
    const loading = this.state.loading;
    const formData = this.state.formData;
    const errors = this.state.errors;
    const errorBackend = this.state.errorBackend;
    const regla = this.state.regla;
    const esEdicion = this.props.action === 'EDIT';
    const rentadorasDisponibles = this.getRentadorasDisponibles();
    const rentadoraSeleccionada = this.state.rentadoraSeleccionada;

    if (redirectTo) {
      return <Redirect push to={redirectTo} />;
    }

    return (
      <React.Fragment>
        {loading && <Loading />}
        <div className="row">
          <div className="col-md-12">

            {errorBackend && (
              <div className="alert alert-danger" role="alert">
                {errorBackend}
              </div>
            )}

            <form className="form form-horizontal" onSubmit={this.handleSubmit}>
              <div className="form-body">
                <div className="card pull-up">
                  <div className="card-content">
                    <div className="card-body">
                      <h4 className="form-section">
                        <i className="icon-settings"></i>
                        {esEdicion ? (
                          <FormattedMessage
                            id="disponibilidadReglas.form.titulo_editar"
                            defaultMessage=" Editar regla de locadora"
                          />
                        ) : (
                          <FormattedMessage
                            id="disponibilidadReglas.form.titulo_agregar"
                            defaultMessage=" Agregar regla de locadora"
                          />
                        )}
                        <div className="float-right" style={{ fontSize: '14px' }}>
                          <FormattedMessage
                            id="disponibilidadReglas.form.campos_requeridos"
                            defaultMessage="* campos requeridos"
                          />
                        </div>
                      </h4>

                      {/* Campo Locadora */}
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label
                              className="col-md-3 label-control col-form-label"
                              htmlFor="rentadora_id"
                            >
                              <FormattedMessage
                                id="disponibilidadReglas.form.locadora"
                                defaultMessage="Locadora *:"
                              />
                            </label>
                            <div className="col-md-9">
                              {esEdicion ? (
                                <div className="form-control-static col-form-label form-value">
                                  {regla ? regla.rentadora_nombre : ''}
                                </div>
                              ) : (
                                <div>
                                  <Autocomplete
                                    size="small"
                                    id="rentadora_id"
                                    name="rentadora_id"
                                    options={rentadorasDisponibles}
                                    value={rentadoraSeleccionada}
                                    defaultValue={null}
                                    getOptionLabel={(option) => option ? option.descripcion : ''}
                                    onChange={this.handleRentadoraChange}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        variant="standard"
                                        placeholder={this.props.intl.formatMessage({
                                          id: 'disponibilidadReglas.form.locadora.placeholder',
                                          defaultMessage: 'Seleccione una locadora',
                                        })}
                                        InputProps={{
                                          ...params.InputProps,
                                          endAdornment: (
                                            <React.Fragment>
                                              {loading ? (
                                                <CircularProgress color="inherit" size={21} />
                                              ) : null}
                                              {params.InputProps.endAdornment}
                                            </React.Fragment>
                                          ),
                                        }}
                                      />
                                    )}
                                  />
                                  {errors.rentadora_id && (
                                    <div className="help-block text-danger field-message">
                                      {errors.rentadora_id}
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Campo Días sin BIP */}
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label
                              className="col-md-3 label-control col-form-label"
                              htmlFor="valor_int"
                            >
                              <FormattedMessage
                                id="disponibilidadReglas.form.dias_sin_bip"
                                defaultMessage="Días sin BIP *:"
                              />
                            </label>
                            <div className="col-md-9">
                              <input
                                type="number"
                                className="form-control"
                                id="valor_int"
                                name="valor_int"
                                min="1"
                                placeholder={this.props.intl.formatMessage({
                                  id: 'disponibilidadReglas.form.dias_sin_bip.placeholder',
                                  defaultMessage: 'Ej: 30',
                                })}
                                value={formData.valor_int}
                                onChange={this.handleInputChange}
                              />
                              {errors.valor_int && (
                                <div className="help-block text-danger field-message">
                                  {errors.valor_int}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card pull-up">
                  <div className="card-content">
                    <div className="card-body">
                      <div className="text-cd text-right">
                        <button type="submit" className="btn btn-primary mr-1">
                          <i className="fa fa-check-circle"></i>
                          <FormattedMessage
                            id="disponibilidadReglas.form.boton_guardar"
                            defaultMessage=" Guardar"
                          />
                        </button>
                        <button
                          type="button"
                          className="btn btn-danger"
                          onClick={this.handleCancelar}
                        >
                          <i className="fa fa-times-circle"></i>{' '}
                          <FormattedMessage
                            id="disponibilidadReglas.form.boton_cancelar"
                            defaultMessage="Cancelar"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default injectIntl(DisponibilidadReglasAbm);
